function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useRTL } from "../../../hooks/useRTL";
import { cn } from "../../../lib/utils";
import { ArrowchevronLeftIcon, ArrowchevronRightIcon } from '@bfe/moly-icons';
import React, { Suspense, lazy, useCallback, useEffect, useRef, useState } from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var Tooltip = /*#__PURE__*/lazy(function () {
  return import("../tooltip");
});
var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var separator = _ref.separator,
    children = _ref.children,
    key = _ref.key,
    isLast = _ref.isLast,
    ellipsis = _ref.ellipsis;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    needTooltip = _useState2[0],
    setNeedTooltip = _useState2[1];
  var itemElement = useRef(null);
  var isRTL = useRTL();
  var currentSeparator = /*#__PURE__*/_jsx("span", {
    className: "text-base-bds-gray-t3 flex items-center",
    children: separator || (isRTL ? /*#__PURE__*/_jsx(ArrowchevronLeftIcon, {}) : /*#__PURE__*/_jsx(ArrowchevronRightIcon, {}))
  });
  useEffect(function () {
    if (!ellipsis) return;
    if (itemElement.current) {
      if (itemElement.current.scrollWidth > itemElement.current.offsetWidth) {
        setNeedTooltip(true);
      }
    }
  }, [ellipsis]);
  var SpanElement = useCallback(function (_ref2) {
    var mr = _ref2.mr;
    return /*#__PURE__*/_jsx("span", {
      ref: itemElement,
      className: cn(mr, 'truncate hover:text-base-bds-gray-t3 cursor-pointer', 'inline-block', 'transition-all', 'font-medium', ellipsis ? 'max-w-[200px]' : ''),
      style: {
        display: 'inherit'
      },
      children: children
    });
  }, [children]);
  var SpanElementToolTips = useCallback(function () {
    return /*#__PURE__*/_jsx(Suspense, {
      children: /*#__PURE__*/_jsx(Tooltip, {
        title: children,
        children: /*#__PURE__*/_jsx(SpanElement, {
          mr: ""
        })
      })
    });
  }, [children]);
  return /*#__PURE__*/_jsxs("div", {
    className: cn('flex', 'items-center', isRTL ? 'ml-[6px]' : 'mr-[6px]', isLast ? 'text-base-bds-gray-t1-title' : 'text-base-bds-gray-t2'),
    children: [needTooltip ? /*#__PURE__*/_jsx(SpanElementToolTips, {}) : /*#__PURE__*/_jsx(SpanElement, {
      mr: isRTL ? 'ml-[6px]' : 'mr-[6px]'
    }), !isLast && currentSeparator]
  }, key);
};
export default BreadcrumbItem;